/* =====================================================================
   KIT PDP · modelo ATIDCOA (Ambiente & Hogar MX, 17-sep-2026)
   Todo va por atributos data-k-*, asi cada seccion pone su HTML.
   · [data-k-slider]  carrusel .k-track con puntos .k-dots
   · [data-k-tabs]    pestanas .k-tab[data-k-tab] + paneles .k-panel[data-k-panel]
   · [data-k-filtro]  pestanas .k-ptab[data-k-grupo] que filtran [data-k-item-grupo]
   · [data-k-dias]    fecha real: hoy menos N dias, en espanol de Mexico
   · [data-k-ir]      enlace que baja suave a su destino (#rvit) sin quedar bajo la cabecera
   · #rvit            vitrina de ofertas: compra y engancha la barra fija del tema
   ===================================================================== */
(function(){
  function $(s,c){return (c||document).querySelector(s);}
  function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}

  /* ---------- fotos diferidas: el HTML las manda sin src y aqui se les pone ----------
     Lo que no se ve no se descarga. El srcset va ANTES del src para que el navegador
     elija el ancho correcto y no se baje el grande. */
  function hidratar(raiz){
    if(!raiz) return;
    $$('img[data-k-src]',raiz).forEach(function(im){
      var ss=im.getAttribute('data-k-srcset');
      if(ss){ im.setAttribute('srcset',ss); im.removeAttribute('data-k-srcset'); }
      im.setAttribute('src',im.getAttribute('data-k-src'));
      im.removeAttribute('data-k-src');
    });
  }

  /* ---------- carruseles con puntos ---------- */
  function sliders(){
    $$('[data-k-slider]').forEach(function(sl){
      var track=$('.k-track',sl), dotsBox=$('.k-dots',sl); if(!track||!dotsBox) return;
      function visibles(){ return $$(':scope > *',track).filter(function(e){return !e.hidden;}); }
      function pintar(){
        var items=visibles(); dotsBox.innerHTML='';
        if(items.length<2){ return; }
        items.forEach(function(it,i){
          var b=document.createElement('button'); b.type='button'; b.className='k-dot'; b.setAttribute('aria-label','Ver '+(i+1)+' de '+items.length);
          b.addEventListener('click',function(){ track.scrollTo({left:it.offsetLeft-track.offsetLeft,behavior:'smooth'}); });
          dotsBox.appendChild(b);
        });
        marcar();
      }
      function marcar(){
        var items=visibles(), dots=$$('.k-dot',dotsBox); if(!dots.length) return;
        var x=track.scrollLeft, mejor=0, dist=1e9;
        items.forEach(function(it,i){ var d=Math.abs((it.offsetLeft-track.offsetLeft)-x); if(d<dist){dist=d;mejor=i;} });
        dots.forEach(function(d,i){ d.classList.toggle('is-on',i===mejor); });
      }
      var t; track.addEventListener('scroll',function(){ clearTimeout(t); t=setTimeout(marcar,60); },{passive:true});
      sl._kRepintar=function(){ track.scrollLeft=0; pintar(); };
      pintar();
      /* las diapositivas que aun no se ven traen la foto sin src: se les pone al acercarse */
      if($('img[data-k-src]',track)){
        if(!('IntersectionObserver' in window)){ hidratar(track); }
        else {
          var io=new IntersectionObserver(function(es){
            es.forEach(function(e){ if(e.isIntersecting){ hidratar(e.target); io.unobserve(e.target); } });
          },{root:track, rootMargin:'0px 300px'});
          $$(':scope > *',track).forEach(function(it){ if($('img[data-k-src]',it)) io.observe(it); });
        }
      }
    });
  }

  /* ---------- pestanas con panel ---------- */
  function tabs(){
    $$('[data-k-tabs]').forEach(function(box){
      var bts=$$('.k-tab',box), pans=$$('.k-panel',box);
      function activar(k){
        bts.forEach(function(b){ var on=b.dataset.kTab===k; b.classList.toggle('is-on',on); b.setAttribute('aria-selected',on?'true':'false'); });
        pans.forEach(function(p){ p.hidden = p.dataset.kPanel!==k; });
      }
      bts.forEach(function(b){ b.addEventListener('click',function(){ activar(b.dataset.kTab); }); });
      if(bts[0]) activar(bts[0].dataset.kTab);
    });
  }

  /* ---------- pestanas que filtran resenas ---------- */
  function filtros(){
    $$('[data-k-filtro]').forEach(function(box){
      var bts=$$('.k-ptab',box), items=$$('[data-k-item-grupo]',box), sl=$('[data-k-slider]',box), tren=$('[data-k-tren]',box);
      function activar(g){
        bts.forEach(function(b){ var on=b.dataset.kGrupo===g; b.classList.toggle('is-on',on); b.setAttribute('aria-pressed',on?'true':'false'); });
        /* Se hidrata ANTES de rearmar el tren: los clones deben salir ya con su foto. */
        items.forEach(function(it){ var on=it.dataset.kItemGrupo===g; it.hidden=!on; if(on) hidratar(it); });
        if(sl&&sl._kRepintar) sl._kRepintar();
        if(tren&&tren._kRearmar) tren._kRearmar();
      }
      bts.forEach(function(b){ b.addEventListener('click',function(){ activar(b.dataset.kGrupo); }); });
      if(bts[0]) activar(bts[0].dataset.kGrupo);
    });
  }

  /* ---------- fechas que se mueven solas ---------- */
  function fechas(){
    var fmt; try{ fmt=new Intl.DateTimeFormat('es-MX',{day:'numeric',month:'short',year:'numeric'}); }catch(e){ return; }
    $$('[data-k-dias]').forEach(function(e){
      var d=new Date(); d.setDate(d.getDate()-(parseInt(e.dataset.kDias,10)||0)); e.textContent=fmt.format(d);
    });
  }

  /* ---------- bajar a la oferta sin quedar debajo de la cabecera ---------- */
  function irA(){
    $$('[data-k-ir]').forEach(function(a){
      a.addEventListener('click',function(ev){
        var destino=$(a.getAttribute('href')); if(!destino) return;
        ev.preventDefault();
        var y=destino.getBoundingClientRect().top+window.pageYOffset-90;
        window.scrollTo({top:y,behavior:'smooth'});
      });
    });
  }

  /* ---------- vitrina de ofertas + barra fija del tema ---------- */
  function vitrina(){
    var raiz=document.getElementById('rvit'); if(!raiz||raiz.dataset.kOk) return; raiz.dataset.kOk='1';
    var cta=document.getElementById('rvitCta'), err=document.getElementById('rvitErr'),
        lab=raiz.querySelector('.rvit-label'), precio=document.getElementById('rvitPrecio');
    var TEXTO=(lab&&lab.textContent)||'Agregar al carrito', ocupado=false;
    function tarjeta(){ return raiz.querySelector('.rvit-card.on'); }
    function precios(){
      var card=tarjeta(); if(!card) return; var pr=card.dataset.precio||'';
      if(precio) precio.textContent=pr;
      $$('#stickyAddToCart .sticky-add-to-cart__button .button-text').forEach(function(e){ e.textContent=TEXTO+' · '+pr; });
    }
    function activar(i){ $$('.rvit-card',raiz).forEach(function(c){ c.classList.toggle('on',c.dataset.i===String(i)); c.setAttribute('aria-pressed',c.dataset.i===String(i)?'true':'false'); }); precios(); }
    $$('.rvit-card',raiz).forEach(function(c){
      c.addEventListener('click',function(){ activar(c.dataset.i); });
      c.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); activar(c.dataset.i); } });
    });
    function ocultarNativo(){
      $$('.shop-add-to-cart-wrapper, .product-form__submit, #_rsi-buy-now-button, ._rsi-buy-now-button').forEach(function(e){
        if(!e.closest('#rvit')) e.style.display='none';
      });
    }
    /* Que se manda al carrito. Con data-base + data-uds se compra la variante de 1 unidad con la
       cantidad del pack (asi al proveedor le entra «2 x» y no «1 x»); el precio lo ajusta un descuento
       automatico de Shopify. Sin esos atributos se mantiene el comportamiento de siempre. */
    function compra(card){
      var base=parseInt(card.dataset.base||'',10), uds=parseInt(card.dataset.uds||'',10);
      if(base>0 && uds>0) return {id:base, q:uds};
      return {id:parseInt(card.dataset.id,10), q:1};
    }
    /* Varias lineas (23-sep, Bijou: un color por bolsa). Si la tarjeta trae data-items (JSON [{id,quantity}])
       se manda tal cual; si no, una sola linea con compra(card), como siempre. */
    function lineas(card){
      if(card.dataset.items){ try{ var L=JSON.parse(card.dataset.items); if(L&&L.length) return L; }catch(e){} }
      var c=compra(card); return [{id:c.id,quantity:c.q}];
    }
    function cargando(on){ cta.disabled=on; if(lab) lab.textContent = on ? 'Un momento…' : TEXTO; }
    function comprar(){
      if(ocupado) return;
      var card=tarjeta();
      if(!card){ err.textContent='Elige una oferta antes de continuar.'; err.style.display='block'; return; }
      /* Checkout propio (A&H COL, 28-sep): si la vitrina trae data-checkout, se va ahí con el pack (?u=N)
         y no se toca el carrito de Shopify. Sin el atributo, todo sigue como siempre. */
      var propio=raiz.getAttribute('data-checkout');
      if(propio){ ocupado=true; cargando(true); window.location.href=propio+(propio.indexOf('?')<0?'?':'&')+'u='+compra(card).q; return; }
      ocupado=true; err.style.display='none'; cargando(true);
      fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
        .then(function(){ return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:lineas(card)})}); })
        .then(function(r){ return r.json().then(function(j){ return {ok:r.ok,j:j}; }); })
        .then(function(res){
          if(!res.ok) throw new Error(res.j.description||res.j.message||'No se pudo agregar');
          /* Colombia: sin Wiio (eso era de Mexico). Va directo a finalizar la compra;
             al acomodar el contra entrega, aqui se conecta el formulario de Releasit. */
          window.location.href='/checkout';
        })
        .catch(function(e){ ocupado=false; cargando(false); err.textContent=e.message||'Hubo un problema. Intenta de nuevo.'; err.style.display='block'; });
    }
    cta.addEventListener('click',comprar);
    /* Al volver con «atrás» desde el checkout propio el botón no debe quedar en «Un momento…». */
    window.addEventListener('pageshow',function(e){ if(e.persisted){ ocupado=false; cargando(false); } });
    /* El boton de la barra fija compra la oferta elegida por el mismo camino. */
    function engancharFijo(){
      $$('#stickyAddToCart .sticky-add-to-cart__button').forEach(function(b){
        if(b.dataset.rvit) return; b.dataset.rvit='1'; b.removeAttribute('onclick'); b.type='button';
        b.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); comprar(); },true);
      });
      precios();
    }
    /* El tema mide su boton nativo (oculto aqui) y nunca mostraria la barra: se mide el de la vitrina. */
    function fijo(){
      var s=document.getElementById('stickyAddToCart'); if(!s) return;
      var ver=cta.getBoundingClientRect().bottom<0;
      if(ver&&!s.classList.contains('show')){ s.style.display='block'; void s.offsetWidth; s.classList.add('show'); }
      else if(!ver&&s.classList.contains('show')){ s.classList.remove('show'); s.style.display='none'; }
    }
    window.addEventListener('scroll',fijo,{passive:true});
    window.addEventListener('resize',fijo,{passive:true});
    window.addEventListener('pageshow',function(e){ if(e.persisted){ ocupado=false; cargando(false); } });
    var on=tarjeta()||raiz.querySelector('.rvit-card'); if(on) activar(on.dataset.i);
    ocultarNativo(); engancharFijo(); fijo();
    var n=0,t=setInterval(function(){ ocultarNativo(); engancharFijo(); fijo(); if(++n>12) clearInterval(t); },300);
  }

  /* ---------- cifras que cuentan y rellenan su anillo o barra al entrar en pantalla ---------- */
  var QUIETO = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function cifras(){
    var items=$$('[data-k-cifra]'); if(!items.length) return;
    var CIRC=2*Math.PI*52;
    function pintar(el,t){
      var v=parseFloat(el.dataset.kCifra)||0, dec=parseInt(el.dataset.kDec,10)||0, rel=(parseFloat(el.dataset.kRelleno)||0)/100;
      var txt=(v*t).toFixed(dec).replace('.',',');
      $$('.k-cuenta',el).forEach(function(b){ b.textContent=txt; });
      var tr=$('.k-an-trazo',el); if(tr){ tr.style.strokeDasharray=CIRC; tr.style.strokeDashoffset=CIRC*(1-rel*t); }
      var bar=$('.k-barra span',el); if(bar){ bar.style.width=(rel*t*100)+'%'; }
    }
    function animar(el){
      if(el.dataset.kHecho) return; el.dataset.kHecho='1';
      if(QUIETO){ pintar(el,1); return; }
      var ini=null, dur=1600;
      (function paso(ts){ if(!ini) ini=ts; var p=Math.min(1,(ts-ini)/dur), e=1-Math.pow(1-p,3); pintar(el,e); if(p<1) requestAnimationFrame(paso); })(performance.now());
    }
    items.forEach(function(el){ pintar(el,0); });
    if(!('IntersectionObserver' in window)){ items.forEach(animar); return; }
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ animar(e.target); io.unobserve(e.target); } }); },{threshold:.45});
    items.forEach(function(el){ io.observe(el); });
  }

  /* ---------- fases que aparecen una a una al bajar ---------- */
  function revelar(){
    $$('[data-k-revelar]').forEach(function(lista){
      var hijos=$$(':scope > *',lista);
      if(QUIETO||!('IntersectionObserver' in window)){ hijos.forEach(function(h){ h.classList.add('k-visto'); }); return; }
      lista.classList.add('k-revelable');
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('k-visto'); io.unobserve(e.target); } });
      },{threshold:.35, rootMargin:'0px 0px -8% 0px'});
      hijos.forEach(function(h){ io.observe(h); });
    });
  }

  /* ---------- resenas en una fila que corre sola, tipo tren lento ----------
     Se detiene mientras se presiona y sigue al soltar. Las copias van con aria-hidden. */
  function trenes(){
    $$('[data-k-tren]').forEach(function(tren){
      var track=$('.k-track',tren); if(!track||tren._kRearmar) return;
      var vel=parseFloat(tren.dataset.kVel)||18, anim=null;
      function armar(){
        if(anim){ anim.cancel(); anim=null; }
        $$(':scope > [data-k-clon]',track).forEach(function(c){ c.remove(); });
        var vis=$$(':scope > *',track).filter(function(e){ return !e.hidden; });
        if(!vis.length) return;
        if(QUIETO||!track.animate){ tren.classList.add('k-tren-quieto'); return; }
        var cs=getComputedStyle(track), gap=parseFloat(cs.columnGap||cs.gap)||0;
        var ancho=vis.reduce(function(s,e){ return s+e.getBoundingClientRect().width+gap; },0);
        var copias=Math.max(1,Math.ceil(tren.getBoundingClientRect().width/ancho));
        for(var c=0;c<copias;c++){
          vis.forEach(function(e){ var k=e.cloneNode(true); k.setAttribute('data-k-clon','1'); k.setAttribute('aria-hidden','true'); k.removeAttribute('data-k-item-grupo'); track.appendChild(k); });
        }
        anim=track.animate([{transform:'translateX(0)'},{transform:'translateX(-'+ancho+'px)'}],{duration:ancho/vel*1000,iterations:Infinity});
      }
      function pausar(){ if(anim) anim.pause(); }
      function seguir(){ if(anim) anim.play(); }
      track.addEventListener('pointerdown',pausar);
      ['pointerup','pointercancel','pointerleave'].forEach(function(ev){ track.addEventListener(ev,seguir); });
      track.addEventListener('touchstart',pausar,{passive:true});
      track.addEventListener('touchend',seguir,{passive:true});
      track.addEventListener('touchcancel',seguir,{passive:true});
      tren._kRearmar=armar;
      armar();
      var rt; window.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(armar,250); });
    });
  }


  /* ---------- videos: el archivo se carga al tocar, nunca al abrir ---------- */
  function videos(){
    $$('[data-k-video]').forEach(function(box){
      var btn=$('.k-vplay',box); if(!btn) return;
      btn.addEventListener('click',function(){
        var url=box.getAttribute('data-k-video'); if(!url) return;
        $$('video').forEach(function(v){ try{ v.pause(); }catch(e){} });
        $$('.k-vbox.is-on').forEach(function(o){ if(o!==box) o.classList.remove('is-on'); });
        var v=$('video',box);
        if(!v){
          v=document.createElement('video');
          v.src=url; v.muted=true; v.loop=true; v.controls=true; v.preload='auto';
          v.setAttribute('playsinline',''); v.setAttribute('muted','');
          box.appendChild(v);
        }
        box.classList.add('is-on');
        var p=v.play(); if(p&&p.catch) p.catch(function(){});
      });
    });
  }



  /* ---------- carrusel que se desplaza solo (no mueve la pista: mueve el scroll) ---------- */
  function deslizaSolo(){
    $$('[data-k-auto]').forEach(function(c){
      if(c._kAuto) return; c._kAuto=true;
      var vel=parseFloat(c.getAttribute('data-k-auto'))||18, pausa=0, prev=null, pos=0;
      function tocar(){ pausa=Date.now()+2500; }
      ['pointerdown','touchstart','wheel','keydown'].forEach(function(ev){ c.addEventListener(ev,tocar,{passive:true}); });
      c.addEventListener('pointerup',function(){ pausa=Date.now()+1200; });
      function visible(){ var r=c.getBoundingClientRect(); return r.bottom>0 && r.top<innerHeight; }
      function paso(ts){
        if(prev===null) prev=ts;
        var dt=Math.min((ts-prev)/1000,0.05); prev=ts;
        var max=c.scrollWidth-c.clientWidth;
        if(Math.abs(c.scrollLeft-pos)>2) pos=c.scrollLeft;   /* si la persona desliza, se sigue desde ahi */
        if(!QUIETO && max>2 && Date.now()>pausa && visible() && document.visibilityState==='visible'){
          pos += vel*dt;                                     /* la posicion se lleva con decimales: */
          if(pos>=max-0.5) pos=0;                            /* scrollLeft redondea y se quedaba quieto */
          c.scrollLeft = pos;
        }
        requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }

  /* filtros() va ANTES de trenes(): si el tren se arma primero, clona las 52 resenas
     (ninguna esta escondida todavia) y el navegador se baja las fotos de todas las pestanas. */
  function init(){ sliders(); tabs(); fechas(); filtros(); trenes(); irA(); vitrina(); cifras(); revelar(); videos(); deslizaSolo(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
